export const messages = {
  labels: {
    trialId: {
      id: 'treatmentSummary.Groups.ClinicalTrial.TrialId',
      defaultMessage: 'ID: ',
    },
    trialDescription: {
      id: 'treatmentSummary.Groups.ClinicalTrial.TrialDescription',
      defaultMessage: 'Description: ',
    },
    startDate: {
      id: 'treatmentSummary.Groups.ClinicalTrial.StartDate',
      defaultMessage: 'Start: ',
    },
    endDate: {
      id: 'treatmentSummary.Groups.ClinicalTrial.EndDate',
      defaultMessage: 'End: ',
    },
    providerName: {
      id: 'treatmentSummary.Groups.ClinicalTrial.ProviderName',
      defaultMessage: 'Care Provider: ',
    },
    institution: {
      id: 'treatmentSummary.Groups.ClinicalTrial.Institution',
      defaultMessage: 'Facility: ',
    },
    providerPhone: {
      id: 'treatmentSummary.Groups.ClinicalTrial.ProviderPhone',
      defaultMessage: 'Phone: ',
    },
    providerEmail: {
      id: 'treatmentSummary.Groups.ClinicalTrial.ProviderEmail',
      defaultMessage: 'Email: ',
    },
    comment: {
      id: 'treatmentSummary.Groups.ClinicalTrial.Comment',
      defaultMessage: 'Comment: ',
    },
  },
};
